export const RANDOM_NUMBER_COOKIE_KEY = "run";
export const RANDOM_NUMBER_COOKIE_KEY_FOR_VARIANT = "variant_run";
